import { MessageCircle, Truck } from "lucide-react";
import { BRAND, WHATSAPP_NUMBER } from "@/config";
import { useCart } from "@/context/CartContext";

export default function Footer() {
  const { setDrawerOpen } = useCart();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0F1015]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div>
            <div className="font-display text-2xl font-extrabold tracking-tight">{BRAND}</div>
            <p className="mt-2 max-w-sm text-sm text-slate-500">
              Premium sublimation blanks, wholesale direct. Compose your order and send it in one tap.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
          <button
            data-testid="footer-track-order-link"
            onClick={() => window.dispatchEvent(new CustomEvent("vs:my-orders"))}
            className="flex items-center gap-2 rounded-full border border-white/15 px-6 py-3.5 text-sm font-semibold text-slate-300 transition-colors hover:border-cyan-400/40 hover:text-cyan-300"
          >
            <Truck size={16} /> Track Your Order
          </button>
          <button
            data-testid="footer-whatsapp-cta"
            onClick={() => setDrawerOpen(true)}
            className="flex items-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-fuchsia-500 px-7 py-3.5 text-sm font-bold text-[#0A0B0E] transition-transform duration-300 hover:scale-105"
          >
            <MessageCircle size={16} /> Start WhatsApp Order
          </button>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/5 pt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} {BRAND} · Manufacturer & Importer since 2010</span>
          <span className="flex items-center gap-4">
            <a href="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-cyan-300">Privacy Policy</a>
            <span>wa.me/{WHATSAPP_NUMBER}</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
